import axios from 'axios';
import { routes } from '../lib/routes';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3000/api',
});

function redirectToLogin() {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  window.location.href = `${base}${routes.login}`;
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      redirectToLogin();
    }
    return Promise.reject(error);
  }
);

export default api;
